export const arraySorter = array => {
    let sortedArray = array.sort((a, b) => 2 * (a.name > b.name) - 1);
    return sortedArray;
}

export const arraySorterBySN = array => {
    let sortedArray = array.sort((a, b) => 2 * (a.serial_number > b.serial_number) - 1);
    return sortedArray;
}